import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const addNewGame = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/create', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_MESSAGE, game: res.data.data };
	});
